import { FaImdb } from '@icon/react-icons';
// import { Divider, Grid, Chip, Avatar, Typography } from '@material-ui/core';
import AssignmentRoundedIcon from '@material-ui/icons/AssignmentRounded';
import ChromeReaderModeTwoToneIcon from '@material-ui/icons/ChromeReaderModeTwoTone';
import Fab from '@material-ui/core/Fab';
import styled from 'styled-components';
import { useFormContext, useController } from 'react-hook-form';
import AddIcon from '@material-ui/icons/Add';
import { ColoredChipIconButton } from '@components/colored-elements';
import { BiEdit, ImDrawer2, TrashFill } from '@icon/react-icons';
import { grey, red } from '@material-ui/core/colors';
import React, { useEffect, useCallback, useMemo, useRef, useState } from 'react';
import {
  Divider,
  Grid,
  Avatar,
  InputLabel,
  TextField,
  Select,
  FormControl,
  Typography,
  Box,
  Chip,
  Link,
  Tooltip,
  Hidden,
  GridSize,
} from '@material-ui/core';
import { SectionTitle, SubSectionTitle, useCompanyFormState } from '../common';
import * as userService from 'services/user';
import { TmdbIcon } from '@icon/tmdb';
import { orange } from '@material-ui/core/colors';
import { CompanyBasicFormField, createTextAttr } from '../fields';
import { HelperTextTip } from '@components/hepler-text-tip';
import ChildCareIcon from '@material-ui/icons/ChildCare';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import LockClosedIcon from '@material-ui/icons/Lock';
import { VerifiedDetails } from './section-utils';
import { rbac } from '@lib/common';

const miscAttrs = [
  createTextAttr('tmdb_company_id', 'TMDB ID', 'TMDB Company ID', <TmdbIcon />),
  createTextAttr('mipcom_company_id', 'MipCom ID', 'MIPCOM Company ID'),
];

const imdbAttrs = [
  createTextAttr(
    'imdb_company_id',
    'IMDb ID',
    <HelperTextTip text="Company ID" tip="[Tip: Usually starts with 'co']" />
  ),
  createTextAttr('imdb_company_name', 'IMDb Name', 'Company Name'),
  // createTextAttr('imdb_vtr_id', 'IMDb Vtr_id', 'IMDb Vtr_id'),
  // createTextAttr(
  //   'imdb_parent_company_id',
  //   'Parent Company ID',
  //   <HelperTextTip
  //     text="Company ID linked as the Parent of this company"
  //     tip="[Tip: Usually starts with 'co']"
  //   />
  // ),
  // createTextAttr('imdb_parent_company_name', 'Parent Company Name', 'Name of the Parent Company'),
];

export const SectionMetadata = ({ imdb_data, parent_child_imdb }) => {
  const form = useFormContext();
  const watchOnChildVtrIds = form.watch('child_vtr_id');
  const initialNumberOfIMDBValues = imdb_data.length;
  const [indexesAttributes, setIndexesAttributes] = useState(
    Array.from(Array(initialNumberOfIMDBValues || 1), (_, i) => i)
  );
  const [counterAttributes, setCounterAttributes] = useState(initialNumberOfIMDBValues || 1);
  const addAttributes = useCallback(() => {
    setIndexesAttributes(prevIndexes => {
      return [...prevIndexes, counterAttributes];
    });
    setCounterAttributes(prevCounter => prevCounter + 1);
  }, [indexesAttributes, counterAttributes]);

  const { edit, company } = useCompanyFormState();
  const { user } = userService.useUser();
  const [isLock, setLock] = useState<boolean>(
    (company &&
      company.verified_sections &&
      company.verified_sections.metadata_section &&
      company.verified_sections.metadata_section.verified) ||
      edit
  );
  const watchOnVerifiedSections = form.watch('verified_sections');
  const verifiedBy =
    watchOnVerifiedSections &&
    watchOnVerifiedSections.metadata_section &&
    watchOnVerifiedSections.metadata_section.verified_by;
  const verifiedAt =
    watchOnVerifiedSections &&
    watchOnVerifiedSections.metadata_section &&
    watchOnVerifiedSections.metadata_section.verified_at + ' IST';

  const removeAttributes = useCallback(index => {
    setIndexesAttributes(prevIndexes => {
      return [...prevIndexes.filter(item => item !== index)];
    });
  }, []);
  return (
    <>
      <Grid container spacing={2} justify="space-between">
        <Grid item>
          <SectionTitle
            id="metadata"
            title="Additional Metadata"
            icon={<ChromeReaderModeTwoToneIcon style={{ color: orange[600] }} fontSize="large" />}
            subTitle="Additional Identifiers of the Company"
          />
        </Grid>
        <Grid item style={{ paddingBottom: '10px' }}>
          <Tooltip
            title={
              isLock ? (
                <>
                  {`Verified by ${verifiedBy}`}
                  <br />
                  {`Verified at ${verifiedAt}`}
                </>
              ) : (
                'Click to Lock the Section'
              )
            }>
            {isLock ? (
              <StyledFab
                color="primary"
                style={{ backgroundColor: 'green' }}
                aria-label="add"
                size="small"
                onClick={() => {
                  setLock(false);
                  form.setValue('verified_sections', {
                    ...form.watch('verified_sections'),
                    metadata_section: { verified: false, verified_by: null, verified_at: null,isLockApplied: false },
                  });
                }}>
                <LockClosedIcon />
              </StyledFab>
            ) : (
              <StyledFab
                color="primary"
                style={{ backgroundColor: 'red' }}
                aria-label="add"
                size="small"
                onClick={() => {
                  setLock(true);
                  form.setValue('verified_sections', {
                    ...form.watch('verified_sections'),
                    metadata_section: {
                      verified: true,
                      verified_by: user.vtr_id,
                      verified_at: new Date().toLocaleString('en-US', { timeZone: 'IST' }),
                      isLockApplied: true,
                    },
                  });
                  // company.verified_sections.metadata_section.verified_by = user.vtr_id;
                  // company.verified_sections.metadata_section.verified = true;
                }}>
                <LockOpenIcon />
              </StyledFab>
            )}
          </Tooltip>
          {isLock && <VerifiedDetails verifiedBy={verifiedBy} verifiedAt={verifiedAt} />}
        </Grid>
      </Grid>

      <Divider />
      <br />
      <div>
      <fieldset disabled={isLock && edit} style={{"border":"none"}}>
        <Grid container justify="space-between" style={{ marginRight: '30px' }}>
          <Grid item>
            <SubSectionTitle
              icon={
                <FaImdb
                  fontSize="large"
                  style={{
                    color: '#f3ce13',
                    background:
                      'radial-gradient(circle, rgba(2,0,36,1) 55%, rgba(255,255,255,1) 55%, rgba(255,255,255,1) 100%)',
                  }}
                />
                // <ImdbIcon fontSize="large" />
              }
              title="IMDb Details"
              subTitle="Company details on IMDb"
            />
          </Grid>
          <Grid item style={{ paddingBottom: '10px' }}>
            <Tooltip title="Add IMDb details">
              <StyledFab
                // disabled={true}
                // disabled={rbac('Company_AddIMDB', '', 'Button') || isLock}
                disabled={isLock}
                onClick={addAttributes}
                color="primary"
                aria-label="add"
                size="small">
                <AddIcon />
              </StyledFab>
            </Tooltip>
          </Grid>
        </Grid>
        </fieldset>
        <Divider />
      
        <br />
        <fieldset disabled={isLock && edit} style={{"border":"none"}}>
        {indexesAttributes.map(indexOfAttribute => {
          return (
            <Grid
              container
              spacing={2}
              justify="flex-start"
              style={{ display: 'flex' }}
              key={indexOfAttribute}>
              {imdbAttrs.map((attr, i) => (
                <>
                  <Grid
                    item
                    key={i}
                    xs={(attr.name === 'imdb_vtr_id' ? 0 : 5) as unknown as GridSize}>
                    {attr.name === 'imdb_company_id' ? (
                      <CompanyBasicFormField
                        {...attr}
                        name={`imdb_company_id[${indexOfAttribute}]`}
                        // disabled={watchOnChildVtrIds[indexOfAttribute] ? true : false}
                        inputProps={{
                          readOnly:
                            watchOnChildVtrIds && watchOnChildVtrIds[indexOfAttribute]
                              ? true
                              : false,
                        }}
                        variant={
                          watchOnChildVtrIds && watchOnChildVtrIds[indexOfAttribute]
                            ? 'filled'
                            : 'outlined'
                        }
                      />
                    ) : (
                      <CompanyBasicFormField
                        {...attr}
                        name={`imdb_company_name[${indexOfAttribute}]`}
                        // disabled={watchOnChildVtrIds[indexOfAttribute] ? true : false}
                       /*  inputProps={{
                          readOnly:
                            watchOnChildVtrIds && watchOnChildVtrIds[indexOfAttribute]
                              ? true
                              : false,
                        }} */
                        variant={
                          watchOnChildVtrIds && watchOnChildVtrIds[indexOfAttribute]
                            ? 'filled'
                            : 'outlined'
                        }
                      />
                    )}
                  </Grid>
                </>
              ))}
              {indexesAttributes.length > 1 ? (
              <Grid
                item
                xs={2}
                style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                <div
                  style={{
                    marginBottom: '10px',
                    // justifyContent: 'center',
                    display: 'flex',
                    alignItems: 'center',
                    // marginRight: '20px',
                  }}>
                  <Tooltip title="Delete Atrribute">
                    <ColoredChipIconButton
                      onClick={() => removeAttributes(indexOfAttribute)}
                      pointer
                      colored={red[900]}
                      disabled={
                        (indexesAttributes.length <= 0 /* || watchOnChildVtrIds[indexOfAttribute] */
                          ? true
                          : false) || (isLock && edit)
                      }
                      size="small"
                      icon={<TrashFill />}
                    />
                  </Tooltip>
                </div>
              </Grid>
               ) : null}
              <CompanyBasicFormField
                // {...attr}
                name={`imdb_vtr_id[${indexOfAttribute}]`}
                style={{ display: 'none' }}
              />
              <CompanyBasicFormField
                // {...attr}
                name={`child_vtr_id[${indexOfAttribute}]`}
                style={{ display: 'none' }}
              />
            </Grid>
          );
        })}
        </fieldset>
        {/* <br />
        <MiscDetails /> */}
        <br />
        {parent_child_imdb.length > 0 && <ParentChildIMDB parent_child_imdb={parent_child_imdb} />}
      </div>
    </>
  );
};
const MiscDetails = () => {
  return (
    <>
      <SubSectionTitle
        title="Miscellaneous"
        subTitle="Other metadata by source."
        icon={<AssignmentRoundedIcon fontSize="large" />}
      />
      <Divider />
      <br />
      <Grid container spacing={3}>
        {miscAttrs.map((attr, i) => (
          <Grid key={i} item xs={6}>
            <CompanyBasicFormField {...attr} />
          </Grid>
        ))}
        {/* <Grid item xs={6}>
          <TextField
            variant="outlined"
            size="small"
            fullWidth
            label="TMDB Name"
            InputProps={tmdbAdornment}
            helperText="Relative company Name in TMDB."
          />
        </Grid> */}
      </Grid>
    </>
  );
};

const ParentChildIMDB = ({ parent_child_imdb }) => {
  const parent_child_imdb_ids = parent_child_imdb.split(',');
  return (
    <>
      <SubSectionTitle
        title="Related IMDB Ids"
        subTitle="Details of related IMDB ids"
        icon={<ChildCareIcon fontSize="large" />}
      />
      <Divider />
      <br />
      <div>
        {parent_child_imdb_ids.length > 0 ? (
          parent_child_imdb_ids.map((each_imdb_id, index) => (
            <Chip
              color="primary"
              label={each_imdb_id}
              key={index}
              style={{ marginRight: '10px', marginBottom: '10px' }}
            />
          ))
        ) : (
          <Typography variant="body2" style={{ fontStyle: 'italic' }}>
            Empty
          </Typography>
        )}
      </div>
    </>
  );
};

const StyledFab = styled(Fab)`
  &.MuiFab-sizeSmall {
    width: 40px;
    // height: 30px;
  }
  & .MuiSvgIcon-root {
    font-size: 1.4rem;
  }
`;
